
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.875 8.25H9.75V4.5h3c.45 0 .75-.3.75-.75S13.2 3 12.75 3h-3V.75C9.75.3 9.45 0 9 0s-.75.3-.75.75V3H7.125A3.361 3.361 0 003.75 6.375c0 1.875 1.5 3.375 3.375 3.375H8.25v3.75H4.5c-.45 0-.75.3-.75.75s.3.75.75.75h3.75v2.25c0 .45.3.75.75.75s.75-.3.75-.75V15h1.125c1.875 0 3.375-1.5 3.375-3.375s-1.5-3.375-3.375-3.375zm-3.75 0A1.857 1.857 0 015.25 6.375c0-1.05.825-1.875 1.875-1.875H8.25v3.75H7.125zM9.75 13.5h1.125c1.05 0 1.875-.825 1.875-1.875s-.825-1.875-1.875-1.875H9.75v3.75z","fill":"#000"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"3","y":"0","width":"12","height":"18"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.875 8.25H9.75V4.5h3c.45 0 .75-.3.75-.75S13.2 3 12.75 3h-3V.75C9.75.3 9.45 0 9 0s-.75.3-.75.75V3H7.125A3.361 3.361 0 003.75 6.375c0 1.875 1.5 3.375 3.375 3.375H8.25v3.75H4.5c-.45 0-.75.3-.75.75s.3.75.75.75h3.75v2.25c0 .45.3.75.75.75s.75-.3.75-.75V15h1.125c1.875 0 3.375-1.5 3.375-3.375s-1.5-3.375-3.375-3.375zm-3.75 0A1.857 1.857 0 015.25 6.375c0-1.05.825-1.875 1.875-1.875H8.25v3.75H7.125zM9.75 13.5h1.125c1.05 0 1.875-.825 1.875-1.875s-.825-1.875-1.875-1.875H9.75v3.75z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#28C76F","d":"M0 0h18v18H0z"}})])])
          )
        }
      }
    